export const mainConfiguration = {
  title: 'OneTrac',
};
